import { NgModule } from '@angular/core';
import { JSONTreePipe } from './json-tree.pipe';
import { FormatNumberPipe } from './format-number.pipe';
import { TimesPipe } from './times.pipe';
import { CommonModule, DecimalPipe } from '@angular/common';
import { GravatarUrlPipe } from './gravatar-url.pipe';
import { FormatDate } from './format-date.pipe';
import { KeysPipe } from './keys.pipe';
import { PropertiesPipe } from './properties.pipe';
import { AllowHtml } from './allow-html.pipe';
import { BoldPipe } from './bold.pipe';
import { DateToString } from './date-to-string.pipe';
import { AbsoluteValuePipe } from './absolute-value.pipe';
import { HexToRgbaPipe } from './hex-to-rgba.pipe';
import { ThousandSuffixPipe } from './thousand-suffix.pipe';
import { CallbackFilterPipe } from './callback-filter.pipe';
import { EnumToArrayPipe } from './enum-to-array.pipe';
import { PrettySecondsPipe } from './pretty-seconds.pipe';
import { RemoveHtmlPipe } from './remove-html.pipe';
import { FilterIconsPipe, FilterNameImg, FilterStringPipe } from './filter-string.pipe';
import { FilterStringIncludeGroupPipe } from './filter-string.pipe';
import { ChunkPipe } from './chunk.pipe';
import { GetAutomationIcons, GetColorAutomationIcons } from './get-automation-icons';
import { GenerateAutomationNames } from './generate-automation-names';
import { AudienceFilterOperatorPipe } from './audience-filter-operator.pipe';
import { MillisecondsToSeconds } from './milliseconds-to-seconds';
import { UnitExtractorPipe } from './unit-extractor.pipe';
import { VisitDurationPipe } from './visit-duration.pipe';
import { FormatCurrencyPipe } from './format-currency.pipe';
import { MarkdownPipe } from './markdown.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    JSONTreePipe,
    FormatNumberPipe,
    TimesPipe,
    GravatarUrlPipe,
    FormatDate,
    KeysPipe,
    PropertiesPipe,
    AllowHtml,
    BoldPipe,
    DateToString,
    AbsoluteValuePipe,
    HexToRgbaPipe,
    ThousandSuffixPipe,
    CallbackFilterPipe,
    EnumToArrayPipe,
    PrettySecondsPipe,
    RemoveHtmlPipe,
    FilterStringPipe,
    FilterStringIncludeGroupPipe,
    FilterNameImg,
    FilterIconsPipe,
    ChunkPipe,
    GetAutomationIcons,
    GetColorAutomationIcons,
    GenerateAutomationNames,
    AudienceFilterOperatorPipe,
    MillisecondsToSeconds,
    UnitExtractorPipe,
    VisitDurationPipe,
    FormatCurrencyPipe,
    MarkdownPipe,
  ],
  exports: [
    JSONTreePipe,
    FormatNumberPipe,
    TimesPipe,
    GravatarUrlPipe,
    FormatDate,
    KeysPipe,
    PropertiesPipe,
    AllowHtml,
    BoldPipe,
    DateToString,
    AbsoluteValuePipe,
    HexToRgbaPipe,
    ThousandSuffixPipe,
    CallbackFilterPipe,
    EnumToArrayPipe,
    PrettySecondsPipe,
    RemoveHtmlPipe,
    FilterStringPipe,
    FilterStringIncludeGroupPipe,
    FilterNameImg,
    FilterIconsPipe,
    ChunkPipe,
    GetAutomationIcons,
    GetColorAutomationIcons,
    GenerateAutomationNames,
    AudienceFilterOperatorPipe,
    MillisecondsToSeconds,
    UnitExtractorPipe,
    VisitDurationPipe,
    FormatCurrencyPipe,
    MarkdownPipe,
  ],
  providers: [DecimalPipe, FormatNumberPipe, ThousandSuffixPipe, GenerateAutomationNames],
})
export class PipesModule {}
